import React from 'react';
import Header from './../Header';
import Footer from './../Footer';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { submitAppeal, loadInspections } from './../../actions/actions'
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { withStyles } from '@material-ui/core/styles';
import Button from '@material-ui/core/Button';
import Typography from '@material-ui/core/Typography';
import SelectInspections from './../controls/SelectInspections';
import AppBar from '@material-ui/core/AppBar';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import TextField from '@material-ui/core/TextField';
import { styles } from './../../helpers/classes';

const TYPE_PERSON = 'TYPE_PERSON';
const TYPE_ORG = 'TYPE_ORG';

const attributes = {
    inspection_id: 'Кому (выберите инспекцию)',
    sender_address: 'Почтовый адрес (адрес места жительсва или пребывания)',
    sender_mail: 'Электронный адрес',
    sender_phone: 'Телефон',
    sender_name: 'Фамилия, имя, отчество заявителя',
    sender_title: 'Полное наименование организации',
    message: 'Текст обращения',
    file: 'Прикрепить файл',
}

function TabContainer(props) {
    return (
        <Typography component="div" style={{ padding: 8 * 2 }}>
            {props.children}
        </Typography>
    );
}

TabContainer.propTypes = {
    children: PropTypes.node.isRequired
};

export class Appeals extends React.Component {
    constructor (props) {
        super(props);
        this.state = {
            value: 0,
            message_type: TYPE_PERSON,
            appeal_form: {
                message_type: TYPE_PERSON,
                inspection_id: '',
                sender_address: '',
                sender_mail: '',
                sender_name: '',
                sender_title: '',
                message: '',
                file: null
            }
        }

    }

    componentWillMount(){
        if (this.props.inspections.length == 0) {
            this.props.loadInspections('no token');
        }
    }

    handleChange = (event, value) => {
        let data = {message_type: value === 0 ? TYPE_PERSON : TYPE_ORG }
        let currentData = this.state.appeal_form;
        console.log(value);
        this.setState({value, appeal_form: {...currentData, ...data}});
    };

    onSelect = event => {
        this.setState({ appeal_form: { ...this.state.appeal_form, ...{ inspection_id: event.target.value } } });
    }
    handleSubmit = () => {
        console.log(this.state.appeal_form);
        this.props.submitAppeal(this.state.appeal_form)
    }
    updateInput = input => {
        let data = {[input.name]: input.value};
        let currentData = this.state.appeal_form;
        this.setState({ appeal_form: {...currentData, ...data}});
    };

    render () {
        const {classes, inspections} = this.props;
        const {value} = this.state;
        return (
            <div>
                <Header/>
                <Typography component="h2" className={classes.headerStatic} variant="headline">Порядок электронных уведомлений граждан</Typography>
                <AppBar position="static" classes={{root: classes.appBar}}>
                    <Tabs
                        value={this.state.value}
                        onChange={this.handleChange}
                        indicatorColor="primary"
                        textColor="primary"
                        fullWidth
                        classes={{indicator: classes.indicator}}
                    >
                        <Tab className={classes.h5} classes={{root: classes.tabRoot, label: classes.tabLabel}} label="Для физических лиц" />
                        <Tab className={classes.h5} classes={{root: classes.tabRoot, label: classes.tabLabel}} label="Для юридических лиц и ИП" />
                    </Tabs>
                </AppBar>
                <TabContainer>
                <form>
                    <SelectInspections onChange={ this.onSelect } items={ this.props.inspections }
                                       value={ this.state.appeal_form.inspection_id }/>
                    <TextField
                        required
                        name="sender_name"
                        onChange={e => this.updateInput(e.target)}
                        id="standard-full-width"
                        label={attributes.sender_name}
                        value={this.state.appeal_form.sender_name}
                        fullWidth
                        margin="normal"
                        className={classes.textField}
                        classes={{root: classes.rootFlex, underline: classes.newColor, filled:classes.newColor,}}
                        InputProps={{
                                        className: classes.input
                                      }}
                        InputLabelProps={{
                                        shrink: true,
                                        className: classes.label
                                      }}
                    />
                    {value === 1 &&
                    <TextField
                        required
                        name="sender_title"
                        onChange={e => this.updateInput(e.target)}
                        id="standard-full-width"
                        label={attributes.sender_title}
                        value={this.state.appeal_form.sender_title}
                        fullWidth
                        margin="normal"
                        className={classes.textField}
                        classes={{root: classes.rootFlex, underline: classes.newColor, filled:classes.newColor,}}
                        InputProps={{
                                        className: classes.input
                                      }}
                        InputLabelProps={{
                                        shrink: true,
                                        className: classes.label
                                      }}
                    />}
                    <TextField
                        required
                        name="sender_address"
                        value={this.state.appeal_form.sender_address}
                        onChange={e => this.updateInput(e.target)}
                        id="standard-full-width"
                        label={attributes.sender_address}
                        fullWidth
                        margin="normal"
                        className={classes.textField}
                        classes={{root: classes.rootFlex, underline: classes.newColor, filled:classes.newColor,}}
                        InputProps={{
                                        className: classes.input
                                      }}
                        InputLabelProps={{
                                        shrink: true,
                                        className: classes.label
                                      }}
                    />
                    <TextField
                        required
                        name="sender_phone"
                        value={this.state.appeal_form.sender_phone}
                        onChange={e => this.updateInput(e.target)}
                        id="standard-full-width"
                        label={attributes.sender_phone}
                        fullWidth
                        margin="normal"
                        className={classes.textField}
                        classes={{root: classes.rootFlex, underline: classes.newColor, filled:classes.newColor,}}
                        InputProps={{
                                        className: classes.input
                                      }}
                        InputLabelProps={{
                                        shrink: true,
                                        className: classes.label
                                      }}
                    />
                    <TextField
                        required
                        name="sender_mail"
                        value={this.state.appeal_form.sender_mail}
                        onChange={e => this.updateInput(e.target)}
                        id="standard-full-width"
                        label={attributes.sender_mail}
                        fullWidth
                        margin="normal"
                        className={classes.textField}
                        classes={{root: classes.rootFlex, underline: classes.newColor, filled:classes.newColor,}}
                        InputProps={{
                                        className: classes.input
                                      }}
                        InputLabelProps={{
                                        shrink: true,
                                        className: classes.label
                                      }}
                    />
                    <TextField
                        required
                        name="message"
                        value={this.state.appeal_form.message}
                        onChange={e => this.updateInput(e.target)}
                        id="standard-full-width"
                        label={attributes.message}
                        fullWidth
                        margin="normal"
                        className={classes.textField}
                        classes={{root: classes.rootFlex, underline: classes.newColor, filled:classes.newColor,}}
                        InputProps={{
                                        className: classes.input
                                      }}
                        InputLabelProps={{
                                        shrink: true,
                                        className: classes.label
                                      }}
                    />
                    <TextField
                        type="file"
                        name="file"
                        onChange={e => this.updateInput(e.target)}
                        id="standard-full-width"
                        label={attributes.file}
                        fullWidth
                        margin="normal"
                        className={classes.textField}
                        classes={{root: classes.rootFlex, underline: classes.newColor, filled:classes.newColor,}}
                        InputProps={{
                                        className: classes.input
                                      }}
                        InputLabelProps={{
                                        shrink: true,
                                        className: classes.label
                                      }}
                    />
                    <Button variant="contained" color="#76b5b8" size="large"
                            className={classes.button}
                            onClick={this.handleSubmit}>
                        Отправить
                    </Button>

                </form>
                </TabContainer>
                <Footer />
            </div>);
    }
}

Appeals.defaultProps = {
    inspections:[],
    message:'',
    status:'',
    classes:{}
}

Appeals.propTypes = {
    classes: PropTypes.object.isRequired,
    status:  PropTypes.string.isRequired,
    message: PropTypes.string.isRequired
}

export const AppealsWithStyles = withStyles(styles)(Appeals);

function select(state, props) {
    const { appeal } = state;
    console.log('SELECT');
    console.log(appeal);
    if (typeof appeal !== "undefined") {
        return {
            inspections: ('inspections' in appeal) ? appeal.inspections : [],
            status: ('status' in appeal) ? appeal.status : 'new',
            message: ('message' in appeal) ? appeal.message : '',
        };
    } else {
        return {
            inspections: [],
            status: 'new',
            message: ''
        }
    }
}

function mapDispatch(dispatch) {
    return {
        submitAppeal: bindActionCreators(submitAppeal, dispatch),
        loadInspections: bindActionCreators(loadInspections, dispatch),
    };
}

export default connect(select, mapDispatch)(AppealsWithStyles);



// WEBPACK FOOTER //
// ./assets/src/js/components/pages/Appeals.jsx